import HttpResponse from '../../components/layouts/HttpResponse';

const NotAuthorized = () => {
  return <HttpResponse number="401" text="Not authorized" />;
};

export default NotAuthorized;
